const stripTrailingSlash = (url = '') => url.replace(/\/+$/, '');

/**
 * Base origin of the booking PWA for the current fleet.
 * - Fleet has custom domain → pwa.customUrl
 * - Otherwise → pwa.pwaLink (query string stripped, e.g. "?f=...")
 */
export const getPwaBaseUrl = (pwaSetting) => {
  const pwa = pwaSetting || {};
  if (pwa.customDomain && pwa.customUrl) {
    return stripTrailingSlash(pwa.customUrl);
  }
  return stripTrailingSlash((pwa.pwaLink || '').split('?')[0]);
};

/**
 * Build `{base}/{fleetToken}/sign-in{query}`.
 * query examples: '?t=b' (migration Try Now), '?corp=' (corporate alias prefix)
 * Falls back to `fallbackPwaLink` (selectedFleet.pwaLink) while the PWA
 * setting API response is not available yet.
 */
export const buildPwaSignInUrl = (pwaSetting, fleetToken, query = '', fallbackPwaLink = '') => {
  const base =
    getPwaBaseUrl(pwaSetting || {}) ||
    stripTrailingSlash((fallbackPwaLink || '').split('?')[0]);
  if (!base || !fleetToken) return '';
  return `${base}/${fleetToken}/sign-in${query}`;
};

export default buildPwaSignInUrl;
